module.exports = __webpack_public_path__ + "media/extraluminal impression.047f86bc.wav";